import { NgModule,Optional, SkipSelf }                from '@angular/core';
import { CommonModule }                               from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi }        from '@angular/common/http';
import { StoreModule }                                from '@ngrx/store';
import { EffectsModule }                              from '@ngrx/effects';

import { WindowWrapper }                              from './services/windowwrapper';

//
// Toyota CDK Service Module(s)
//

import { AddHeaderInterceptor }                       from './interceptors/add-header.interceptor';
import { UnauthorizedComponent }                      from './components/unauthorized/unauthorized.component';
import { throwIfAlreadyLoaded }                       from './module-import-guard';

import { reducers }                                   from './state/reducers';
import { effects }                                    from './state/effects';

import { LoaderComponent } from './components/general/con-app-loader/con-app-loader';
import { ConAppNavBar } from './components/general/con-app-navbar/con-app-navbar';
import { LoaderService } from './services/loader.service';
import { ConAppNotificationPanel }                    from './components/general/con-app-notification-panel/con-app-notification-panel';
import { ConAppToaster }                              from './components/general/con-app-toaster/con-app-toaster';

//
// third party libraries
//
import { ToastrModule } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { ModalComponent } from './components/general/modal/modal.component';
import { DealServiceInterceptor } from './interceptors/deal-service.interceptor';
import { ConAppChatNotificationPanelComponent } from './components/general/con-app-chat-notification-panel/con-app-chat-notification-panel.component';
import { ConAppIdleTimeoutModalComponent } from './components/general/con-app-idle-timeout-modal/con-app-idle-timeout-modal.component';
import { A11yModule } from '@angular/cdk/a11y';
export function getWindow() { return window; }


@NgModule({ declarations: [UnauthorizedComponent, LoaderComponent, ConAppNavBar, ConAppNotificationPanel, ConAppToaster, ModalComponent, ConAppChatNotificationPanelComponent, ConAppIdleTimeoutModalComponent],
    exports: [
        UnauthorizedComponent,
        LoaderComponent,
        ConAppNavBar,
        ConAppNotificationPanel,
        ConAppChatNotificationPanelComponent,
        ConAppIdleTimeoutModalComponent
    ], imports: [CommonModule,
        A11yModule,
        FormsModule,
        //
        // Third party
        //
        ToastrModule.forRoot(),
        //
        // NgRx
        //
        StoreModule.forFeature('AppCoreState', reducers),
        EffectsModule.forFeature(effects)], providers: [
        LoaderService,
        { provide: HTTP_INTERCEPTORS, useClass: AddHeaderInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: DealServiceInterceptor, multi: true },
        { provide: WindowWrapper, useFactory: getWindow },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class CoreModule {
  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
 }
